/**
* In this file contains the Physician login screen UI designs and login forms functionality
**/

import { Link ,useNavigate } from 'react-router-dom';
import constantVariables from './../../dataset/constantVariables.json';
import { validate } from './../../services/ValidationService';
import { useState,useEffect } from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import ApiService from './../../services/ApiService';
import PhoneInput from 'react-phone-input-2'

//Physician Login page
function PhysicianLogin() {
  
  //Variable declaration
  const [data,setData]=useState({});
  const [error,setError]=useState({});
  const [usephone, setUsephone ]= useState(false);
  const [isValid,setIsValid]=useState(true);
  const navigate =useNavigate();
  
  //validate patterns
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobilePattern =  /^[\d()+ -]{10,}$/;
	 
   /**
   * Validation schema for login form
   * @email pass the email
   * @mobileNumber pass the mobile number
   **/
   const loginFields = [
    { name: 'username', validation: Yup.string().test('is-email-or-mobile', constantVariables.error.validUserName, (value) => { return emailPattern.test(value) || mobilePattern.test(value); }).required(constantVariables.error.userName)}
   ];
   
   
   //use phone number
   const toggleUsername=()=>{
	setUsephone(!usephone);
	setData({});
   }

   //To close OTP Model
   /* const handleClose = () => setModal({});
    */
   /** 
	* To handle input fields change function
	* @e we capture the input fields events
	**/
  const handleChange=async(e)=>{
	  e.preventDefault();
	  const {name,value}=e.target; 
	  setData({...data,[name]:value});
	  const Errors = await validate({ [name]: value }, loginFields);
	  setError({...error,[name]:Errors[name]});
  };

    /** 
  * To check phone number valid or not 
  * @value - we pass the actual phone number
  * @country - we pass the countryCode
  * @e - we get the event details from the onChange action
  * @formattedValue - we pass the country formatted Value
  **/

	const handlePhone = async (value, country, e, formattedValue) => {
		const { format, dialCode } = country;
		const updatedUsername = formattedValue.replace('+' + dialCode, '+' + dialCode + ' ').replace(/[-\s]+/g, '');
		setData({
			...data,
			username: updatedUsername,
			countryCode: '+' + dialCode,
			countryNameCode: country?.countryCode
		});
		const Errors = await validate({ username: updatedUsername }, loginFields);
		setError({ ...error, username: Errors.username });
		if (!formattedValue || (format?.length === formattedValue?.length && (value.startsWith(dialCode) || dialCode.startsWith(value)))) {
			setIsValid(true);
		} else {
			setIsValid(false);
		}
	}
	
  
  /**
  * To handle login submit function
  * @e we capture the login form events
  **/
  const handleSubmit=async(e)=>{
	  e.preventDefault();
	  const Errors = await validate(data, loginFields);
	  setError(Errors);
	  if(!Object.keys(Errors).length){
		 
		  var request={};
		     request.username =data.username;
		  var response = await ApiService.login(request);
		  if(response?.status===200){
			  if(response?.data?.message==='OTP sent successfully to email' || 'OTP sent successfully to mobile number'){
				const propsToPass = {
					id: response.data.user,
					username: data.username
				};
				toast.success(response?.data?.message);
				navigate('/login/verify', { state: propsToPass });
			}
		  }else{
			  toast.error(response?.data?.message||'Something went wrong');
		  }
	        	 
	  }
  }
   
   //Component Initialize function
   useEffect(()=>{
	//To check the token exist or not
	  var token = localStorage.getItem('token');
	     if(token){
			navigate(parseInt(localStorage.getItem('role'))===3?'/admin/dashboard':'/physician/dashboard');
		 } 
		 // eslint-disable-next-line
   },[]);

  return (
  <>
    {/** Physician Login page  **/}
<main className="login-sec">
    <div className="container">
     
      <section className="register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
		{/** Logo **/}
          <div className="row justify-content-center">
            <div className="col-lg-12">
				<div className="d-flex justify-content-center pb-5">
					<Link to='/'  className="login-logo d-flex align-items-center">
						<img src="/assets/img/nurture-logo.svg" alt="lo" />
					</Link>
				</div>
				
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-10">
				<div className="wrap d-md-flex">
					<img src="/assets/img/physician-login-img.jpg" alt="lo" />
					
					{/** Login form **/}				
					<div id="loginForm">
						<h1>{constantVariables.auth.physicianLogin}</h1>
						<h5>{usephone?constantVariables.auth.phoneLogin:constantVariables.auth.emailLogin}</h5>
						
						<form onSubmit={handleSubmit} autoComplete="off">
						  <div className="form-group mb-2">
							<label className="mb-1">{usephone?constantVariables.auth.phone:constantVariables.auth.emailId}</label>
							{usephone ?
							<>
							<PhoneInput
							inputProps={{
							name: 'username',
							style: { width: '100%'},
							className:'form-control', 
							placeholder:'Enter Phone Number'
							}}
							country={'in'}
							 onChange={handlePhone}
						  /> 
							{error && error.username && <span className="text-danger">{error.username}</span>}
						  </>:<>
							<input type="text" value={data.username?data.username:''} name="username" onChange={handleChange} className="form-control" placeholder={usephone?constantVariables.auth.enterPhone:constantVariables.auth.enterEmail}/>
							<i className="iconly-Light-Message"></i>
							{error && error.username && <span className="text-danger">{error.username}</span>}
							</>
							}
						  </div>
						  <div className="form-group text-end mb-4">
							<a onClick={toggleUsername} className="text-tmPink">{usephone?constantVariables.auth.useEmail:constantVariables.auth.usePhone}</a>
						  </div>				
						  <div className="mb-5">
							<button type="submit" className="btn btn-tmBlue w-100">
							{constantVariables.auth.sendCode}</button>
						  </div>
						</form>
						{/*<div className="footer-text">
							<p>New to Nurture? <Link to='/register' className="ml-1"> {constantVariables.auth.registerNow}</Link></p>
						</div>*/}
					</div>
					{/** Login form end **/}
				</div>
            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
  {/** Login page end **/}
  </>
  );
}


export default PhysicianLogin;
